import { render, staticRenderFns } from "./IndexNavigation.vue?vue&type=template&id=c0a15e72"
import script from "./IndexNavigation.vue?vue&type=script&lang=js"
export * from "./IndexNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports